(() => {
  const moveLocationBadges = () => {
    document.querySelectorAll('product-card .product-card__content > .location-badge-slot--card').forEach((slot) => {
      const card = slot.closest('product-card');
      if (!card) return;

      const media = card.querySelector('.card-gallery, .product-card__media, .product-card-gallery, .product-card__image-wrapper');
      if (media && !media.contains(slot)) media.appendChild(slot);
    });
  };

  const bindLocationBadges = () => {
    document.querySelectorAll('.location-badge--card-overlay').forEach((badge) => {
      if (badge.dataset.pdlLocationBound === 'true') return;
      badge.dataset.pdlLocationBound = 'true';

      badge.addEventListener('click', (event) => {
        if (window.matchMedia('(hover: none)').matches) {
          event.preventDefault();
          event.stopPropagation();

          document.querySelectorAll('.location-badge--card-overlay.is-open').forEach((item) => {
            if (item !== badge) item.classList.remove('is-open');
          });

          badge.classList.toggle('is-open');
        }
      });
    });
  };

  const init = () => {
    moveLocationBadges();
    bindLocationBadges();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
